import React from "react";

const MapaLugares = ({
  selected,
  rows,
  place,
  setPlace,
  icon,
  taken_spots,
}) => {
  const total = rows.reduce((a, b) => a + b);

  const getCurrentLugar = (rowIndex, index) => {
    let ascending = parseInt(rowIndex) !== parseInt(rows) - 1;
    return ascending
      ? total - getSum(rowIndex) + index - rows[rowIndex] + 1
      : total - getSum(rowIndex) - index;
  };

  const getSum = (rowIndex) => {
    let sum = 0;
    for (let i = 0; i < rowIndex; i++) {
      sum += rows[i];
    }
    return sum;
  };

  const isPlaceTaken = (taken_spots, rowIndex, index) => {
    if (Array.isArray(taken_spots)) {
      return Array.from(taken_spots).includes(
        `${getCurrentLugar(rowIndex, index)}`
      );
    }
    return false;
  };

  const isPlaceSelected = (rowIndex, index) => {
    return parseInt(selected) === getCurrentLugar(rowIndex, index);
  };

  const isPlaceBeingSelected = (rowIndex, index) => {
    return parseInt(place) === getCurrentLugar(rowIndex, index);
  };

  const getButtonClassName = (rowIndex, index) => {
    if (Array.isArray(taken_spots)) {
      if (
        isPlaceSelected(rowIndex, index) ||
        isPlaceBeingSelected(rowIndex, index)
      ) {
        return "pink";
      }
      if (isPlaceTaken(taken_spots, rowIndex, index)) {
        return "secondary";
      }
      return "light";
    }
  };

  return (
    <div>
      <p className="bold">{icon ? "Selecciona tu Lugar" : "Lugares"}</p>
      {rows.map((cols, rowIndex) => (
        <div key={rowIndex} className="row my-3">
          {new Array(cols).fill(1).map((one, index) => (
            <div key={index} className={`col mb-3 text-center spot-col`}>
              <button
                className={`btn btn-sm btn-${getButtonClassName(
                  rowIndex,
                  index
                )}`}
                onClick={() => setPlace(`${getCurrentLugar(rowIndex, index)}`)}
                disabled={
                  isPlaceTaken(rowIndex, index) ||
                  (selected && selected !== null)
                }
              >
                {icon && (
                  <i
                    className={`${icon} ${
                      isPlaceTaken(taken_spots, rowIndex, index)
                        ? "text-dark"
                        : place === `${getCurrentLugar(rowIndex, index)}`
                        ? "text-primary"
                        : "text-success"
                    }`}
                  />
                )}
                <p className="mb-0">{`${getCurrentLugar(rowIndex, index)}`}</p>
              </button>
            </div>
          ))}
        </div>
      ))}
      <div className="container-fluid px-0 py-1 bg-dark text-center mb-3">
        <p className="text-primary mb-0 small bold">Coach</p>
      </div>
    </div>
  );
};

export default MapaLugares;
